import { Divider } from 'antd'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import React from 'react'
import styled from 'styled-components'
import Checkbox from '../../../../../../components/Form/Checkbox'

const Container = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: row;
  justifycontent: spaceBetween;
`
const FilterGroup = styled.div`
  ${
    '' /* display: flex;
  align-items: center; */
  }
`

const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
`

const EvaluvactionScheduleFilter = ({
  scheduleValue,
  handleChangeSchedule,
  scheduleStatus,
  ScheduleStatus,
  scheduleData,
  handleScheduleChange,
}) => {
  return (
    <Container style={{ height: '100%' }}>
      <FilterGroup>
        <Label>Status</Label>
        {ScheduleStatus.map((item, index) => (
          <>
            <Checkbox
              label={item.label}
              checked={scheduleStatus === item.value}
              value={item.value}
              key={index + 'checkboxes'}
              onChange={handleChangeSchedule}
              style={{ paddingTop: 20 }}
            />
            <br />
          </>
        ))}
      </FilterGroup>

      {scheduleStatus === 'SCHEDULED' && scheduleData?.length > 0 && (
        <>
          <Divider type="vertical" style={{ height: 'auto' }} />
          <FilterGroup>
            <Label>Interview Type</Label>
            <FilterCheckBoxComp
              options={scheduleData}
              value={scheduleValue}
              onChange={handleScheduleChange}
            />
          </FilterGroup>
        </>
      )}
    </Container>
  )
}

export default EvaluvactionScheduleFilter
